<template>
  <wb-modal ref="modal" class="emh-campaign-modal" :mode.attr="'info'" @wbclose="close">
    <wb-modal-header />
    <wb-modal-content>
      <div v-for="campaign in campaigns" :key="campaign.name" class="emh-campaign-modal__campaign-wrapper">
        <h3 class="emh-campaign-modal__headline">
          {{ campaign.name }}
          <local-footnote-reference v-if="campaign.footnote" :text="campaign.footnote" context="modal" />
        </h3>
        <p class="emh-campaign-modal__description">
          {{ campaign.description }}
        </p>
      </div>
      <local-footnote-container context="modal" />
    </wb-modal-content>
  </wb-modal>
</template>

<script lang="ts">
import { Components } from '@workbench/core';
import { defineComponent, onMounted, PropType, ref } from 'vue';
import { DCPBadgeDTO } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';
import { useI18n } from '../../composables/i18n.composable';
import LocalFootnoteReference from '../localFootnotes/localFootnoteReference.vue';
import LocalFootnoteContainer from '../localFootnotes/localFootnoteContainer.vue';

export default defineComponent({
  name: 'CampaignModal',
  components: {
    LocalFootnoteContainer,
    LocalFootnoteReference,
  },
  props: {
    campaigns: {
      type: Array as PropType<DCPBadgeDTO[]>,
      default: () => [],
    },
  },
  emits: ['close'],
  setup(_props, { emit }) {
    const modal = ref<Components.WbModal>();
    const { t } = useI18n();

    const close = () => emit('close');

    onMounted(() => {
      modal.value!.scrollLock = true;
      modal.value!.closeOnBackdropClick = true;
      modal.value!.closeOnEscapeKey = true;
    });

    return {
      close,
      modal,
      t,
    };
  },
});
</script>

<style scoped lang="scss">
.emh-campaign-modal {
  // 1 above srp sticky-bar. And sticky-bar is 1 above fcis-popup which we don't control
  z-index: 1002;

  &__campaign-wrapper {
    &:not(:last-of-type) {
      @include wb-spacing('margin-bottom', xs);
    }

    &:not(:first-child) {
      @include wb-spacing('padding-top', s);

      border-top: 1px solid var(--wb-grey-85);
    }
  }

  &__headline {
    @include wb-type-heading-m;

    color: var(--wb-color-black);
  }
}
</style>
